import React from 'react';

export function Marquee({
  className = '',
  reverse = false,
  pauseOnHover = false,
  vertical = false,
  repeat = 2,
  gap = '1rem',
  children,
  style = {},
}) {
  return (
    <div
      className={`group flex overflow-hidden ${vertical ? 'flex-col' : 'flex-row'} ${className}`}
      style={{ '--duration': '40s', '--gap': gap, ...style }}
    >
      {Array.from({ length: repeat }).map((_, i) => (
        <div
          key={i}
          className={`flex shrink-0 ${vertical ? 'flex-col' : 'flex-row'} gap-[--gap] ${
            pauseOnHover ? 'group-hover:[animation-play-state:paused]' : ''
          }`}
          style={{
            animation: vertical
              ? `marquee-scroll-vertical var(--duration) linear infinite${reverse ? ' reverse' : ''}`
              : `marquee-scroll var(--duration) linear infinite${reverse ? ' reverse' : ''}`,
          }}
        >
          {children}
        </div>
      ))}
      <style>{`
        @keyframes marquee-scroll {
          from { transform: translateX(0); }
          to   { transform: translateX(calc(-100% - var(--gap))); }
        }
        @keyframes marquee-scroll-vertical {
          from { transform: translateY(0); }
          to   { transform: translateY(calc(-100% - var(--gap))); }
        }
      `}</style>
    </div>
  );
}
